<template>
  <!-- Dark / light switch in the header. Dark is the default; the choice is kept in this browser. -->
  <button
    type="button"
    class="theme-switch"
    :title="isDarkMode ? t('theme.toLight') : t('theme.toDark')"
    :aria-label="isDarkMode ? t('theme.toLight') : t('theme.toDark')"
    :aria-pressed="!isDarkMode"
    @click="darkStore.toggleDarkMode()"
  >
    <v-icon :icon="isDarkMode ? 'mdi-weather-sunny' : 'mdi-weather-night'" size="18"></v-icon>
  </button>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { useDarkModeStore } from "@/stores";
import { t } from "@/i18n";

const darkStore = useDarkModeStore();
const { isDarkMode } = storeToRefs(darkStore);
</script>

<style scoped>
.theme-switch {
  display: inline-grid;
  place-items: center;
  width: 34px;
  height: 34px;
  margin: 0 4px;
  border: 1px solid var(--ui-line);
  border-radius: 50%;
  background: transparent;
  color: var(--ui-dim);
  cursor: pointer;
  transition: color 150ms ease, border-color 150ms ease;
}
.theme-switch:hover,
.theme-switch:focus-visible {
  color: var(--ui-pri);
  border-color: var(--ui-pri);
  outline: none;
}
</style>
